import { Component, Input } from '@angular/core';
import { Warehouse } from '../../models/warehouse.model';

@Component({
    selector: 'app-warehouse-form',
    templateUrl: './warehouse-form.component.html',
    styleUrls: ['./warehouse-form.component.scss'],
    standalone: false
})
export class WarehouseFormComponent {

  @Input()
  warehouse: Warehouse;
}
